import { component } from 'picoapp';
import throttle from 'lodash/throttle';
import { repaint } from 'utils/node';

// NOTE: this script handles both the static and sticky header based on the position variable

export default component(async (node) => {
  const mobileMenuBtn = node.querySelector('[data-mobile-menu-btn]');
  const searchBtn = node.querySelector('[data-search-btn]');
  const cartBtn = node.querySelector('[data-cart-btn]');
  const quizBtns = node.querySelectorAll('[data-quiz-btn]');

  const { position } = node.dataset;
  const headerActiveClass = 'header--active';

  const initScroll = () => {
    let previousPosition = window.scrollY;

    const handleScroll = () => {
      const handleStatic = () => {
        const staticBottom = window.scrollY + node.getBoundingClientRect().bottom;

        if (window.scrollY > staticBottom) {
          document.dispatchEvent(new Event('header:stick'));
        } else {
          document.dispatchEvent(new Event('header:unstick'));
        }
      };

      const handleSticky = () => {
        const currentPosition = window.scrollY;
        const isActive = currentPosition < previousPosition && node.dataset.sticky === 'true';

        node.classList[isActive ? 'add' : 'remove'](headerActiveClass);
        previousPosition = currentPosition;
      };

      switch (position) {
        case 'static':
          handleStatic();
          break;

        case 'sticky':
          handleSticky();
          break;

        default:
          break;
      }
    };

    window.addEventListener('scroll', throttle(handleScroll, 100));

    if (position === 'sticky') {
      const stick = () => {
        node.dataset.sticky = 'true';
        node.hidden = false;
        repaint(node);
      };

      const unstick = () => {
        node.dataset.sticky = 'false';
        node.classList.remove(headerActiveClass);

        node.addEventListener('transitionend', () => {
          if (node.dataset.sticky === 'false') {
            node.hidden = true;
          }
        }, { once: true });
      };

      document.addEventListener('header:stick', stick);
      document.addEventListener('header:unstick', unstick);
    }
  };

  const initMobileMenuBtn = () => {
    mobileMenuBtn.addEventListener('click', () => document.dispatchEvent(new Event('mobileMenu:open')));
  };

  const initSearchBtn = () => {
    searchBtn.addEventListener('click', () => {
      document.dispatchEvent(new Event('liveSearch:open'));
    });
  };

  const initCartBtn = () => {
    cartBtn.addEventListener('click', () => {
      document.dispatchEvent(new Event('cart:open'));
    });

    document.addEventListener('cart:updated', (event: CustomEvent) => {
      const { headerMarkup } = event.detail;
      const container = document.createElement('div');
      container.innerHTML = headerMarkup;

      const containerCartBtn = container.querySelector('[data-cart-btn]');
      cartBtn.innerHTML = containerCartBtn.innerHTML;
    });
  };

  const initQuizBtns = () => {
    quizBtns.forEach((btn) => {
      btn.addEventListener('click', () => document.dispatchEvent(new Event('quiz:open')));
    });
  };

  const init = () => {
    initScroll();
    initMobileMenuBtn();
    initSearchBtn();
    initCartBtn();
    initQuizBtns();
  };

  init();
});
